module.exports = __webpack_public_path__ + "img/icon-undo.aa7470a8.svg";